module.exports = __webpack_public_path__ + "static/media/SmartShop_8-264w.13860633.png";